module.exports = __webpack_public_path__ + "img/wordcloud-aija-lagdzina.11e6427a.png";